import { AppliedFilterInterface, FilterInterface, Select } from '@shopify/polaris'
import { useCallback } from 'react'

import countries from '../../common/countries.json'
import { SubscriptionFilter } from '../api'

export const useAddDeliveryCountryCodeFilter = (
  filter: SubscriptionFilter,
  updateFilter: (newFilter: Partial<SubscriptionFilter>) => any,
  filters: FilterInterface[],
  appliedFilters: AppliedFilterInterface[]
) => {
  const setDeliveryCountryCode = useCallback(
    (delivery_country_code?: string) => updateFilter({ delivery_country_code }),
    [updateFilter]
  )
  const clearDeliveryCountryCode = useCallback(
    () => setDeliveryCountryCode(undefined),
    [setDeliveryCountryCode]
  )

  const countryOptions = countries.map((c) => ({
    label: c.title,
    value: c.value,
  }))

  filters.push({
    key: 'deliveryCountryCode',
    label: 'Delivery country',
    filter: (
      <Select
        label="Delivery country"
        labelHidden
        options={countryOptions}
        value={filter.delivery_country_code}
        onChange={setDeliveryCountryCode}
        placeholder="Select a country"
      />
    ),
  })

  if (filter.delivery_country_code) {
    appliedFilters.push({
      key: 'deliveryCountryCode',
      label: `Delivery country: ${filter.delivery_country_code}`,
      onRemove: clearDeliveryCountryCode,
    })
  }
}
